import React from 'react';

export const Tag = ({ width = 20, height = 20, className, style }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      style={style}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M7.08333 7.91667C7.54357 7.91667 7.91667 7.54357 7.91667 7.08333C7.91667 6.6231 7.54357 6.25 7.08333 6.25C6.6231 6.25 6.25 6.6231 6.25 7.08333C6.25 7.54357 6.6231 7.91667 7.08333 7.91667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.33325 5.83398V9.04982C3.33325 9.49732 3.51075 9.92648 3.82742 10.2432L10.5908 17.0065C10.7475 17.1632 10.9335 17.2875 11.1382 17.3724C11.343 17.4572 11.5625 17.5008 11.7841 17.5008C12.0057 17.5008 12.2252 17.4572 12.4299 17.3724C12.6347 17.2875 12.8207 17.1632 12.9774 17.0065L17.0058 12.9782C17.1625 12.8214 17.2868 12.6354 17.3716 12.4307C17.4564 12.2259 17.5001 12.0064 17.5001 11.7848C17.5001 11.5632 17.4564 11.3437 17.3716 11.139C17.2868 10.9342 17.1625 10.7482 17.0058 10.5915L10.2416 3.82815C9.92528 3.5119 9.49637 3.33416 9.04909 3.33398H5.83325C5.17021 3.33398 4.53433 3.59738 4.06549 4.06622C3.59664 4.53506 3.33325 5.17094 3.33325 5.83398V5.83398Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};
